/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import {
  BuilderFormSchemaFactory,
  BuilderUserContext, FormRootSchema,
  FormState,
  FormStateSchema,
} from '@gh/builder-shared';
import { BuilderPermission, PRIVILEGED_EP_SYS_VARS_SALES } from '@gh/builder-shared-data';
import { NumberTypes, whenEditMode } from '@gh/common-shared';

import { FormMode } from '@gh/core-ui';
import { SystemVarsSales } from '../../resources/model/system-vars-sales.model';

@Injectable()
export class SystemVarsSalesFormState extends FormState<SystemVarsSales> {
  constructor(schemaFactory: BuilderFormSchemaFactory,
              private userContext: BuilderUserContext) {
    super(schemaFactory);
  }

  protected buildSchema(value: SystemVarsSales, { root }: FormStateSchema): FormRootSchema {
    const mode = this.userContext.hasPermission(BuilderPermission.Setup.SystemVariables.Sales.EDIT) ?
      FormMode.EditMode : FormMode.ViewMode;

    return root({
      enabled: whenEditMode(),
      mode,
      privilegedEntryPoints: [PRIVILEGED_EP_SYS_VARS_SALES],
      optimisticLock: true,
      children: {
        nextQuoteNumber: { required: true, type: NumberTypes.QuoteNumber },
        canSelectPdf: { privileged: PRIVILEGED_EP_SYS_VARS_SALES },
        rfqClone: { required: true },
        quickQuotesAllowed: void 0,
        rfqAdjustmentPct: { required: true },
        rfqValidDays: { type: NumberTypes.Days },
        rfqParagraph1: void 0,
        rfqParagraph2: void 0,
        useSalesEstimates: void 0,
        salesPersonCanSeeSalesEstimates: void 0,
        contactLetterPromptPrint: void 0,
      },
    });
  }
}
